import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-home',
  templateUrl: './form-home.component.html',
  styleUrls: ['./form-home.component.scss']
})
export class FormHomeComponent implements OnInit {

  idcomodity:number
  constructor() { }

  ngOnInit() {
    this.idcomodity=1;
  }

}



// WEBPACK FOOTER //
// ./src/app/form-home/form-home.component.ts